export default __webpack_public_path__ + "static/media/3435 spice rack F top.85d0e5cd.png";